import { lazy } from 'react';
export var CourseEditPageAsync = lazy(function () { return import('./CourseEditPage'); });
